// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Core__Option = require("@rescript/core/src/Core__Option.res.js");
var MM_wrk_editor = require("../worker/MM_wrk_editor.res.js");
var PaginationCmp = require("../ui-utils/PaginationCmp.res.js");
var Expln_React_Row = require("../../rescript-utils/main/react-mui-components/Expln_React_Row.res.js");
var MM_cmp_user_stmt = require("./MM_cmp_user_stmt.res.js");
var MM_editor_history = require("../worker/MM_editor_history.res.js");
var Expln_React_Column = require("../../rescript-utils/main/react-mui-components/Expln_React_Column.res.js");
var Static_XML_to_HTML = require("../utils/Static_XML_to_HTML.res.js");
var Paper = require("@mui/material/Paper").default;
var Local_storage_utils = require("../ui-utils/Local_storage_utils.res.js");
var AppBar = require("@mui/material/AppBar").default;
var Button = require("@mui/material/Button").default;
var IconButton = require("@mui/material/IconButton").default;
var Bookmark = require("@mui/icons-material/Bookmark").default;
var BookmarkBorder = require("@mui/icons-material/BookmarkBorder").default;

function MM_cmp_editor_hist(props) {
  var onRestore = props.onRestore;
  var stepsPerPage = props.stepsPerPage;
  var viewOptions = props.viewOptions;
  var onClose = props.onClose;
  var hist = props.hist;
  var editorState = props.editorState;
  var modalRef = props.modalRef;
  var match = React.useState(function () {
        if (MM_editor_history.editorHistLength(hist) > 0) {
          return 0;
        } else {
          return -1;
        }
      });
  var setCurIdx = match[1];
  var curIdx = match[0];
  var match$1 = React.useState(function () {
        return MM_editor_history.editorHistGetSnapshotPreview(hist, curIdx, editorState);
      });
  var setCurEditorState = match$1[1];
  var curEditorState = match$1[0];
  var match$2 = Local_storage_utils.useStateFromLocalStorageBool("editor-hist-showBkmOnly", false);
  var setShowBkmOnly = match$2[1];
  var showBkmOnly = match$2[0];
  var match$3 = React.useState(function () {
        return 0;
      });
  var setPageIdx = match$3[1];
  var paginationData;
  if (curEditorState.TAG === "Ok") {
    var editorState$1 = curEditorState._0;
    var thereAreBkmSteps = editorState$1.stmts.some(function (stmt) {
          if (stmt.typ !== "E" && !stmt.isGoal) {
            return stmt.isBkm;
          } else {
            return false;
          }
        });
    var stmtsToShow = thereAreBkmSteps && showBkmOnly ? editorState$1.stmts.filter(function (stmt) {
            if (stmt.typ === "E" || stmt.isGoal) {
              return true;
            } else {
              return stmt.isBkm;
            }
          }) : editorState$1.stmts;
    var numOfPages = Math.ceil(stmtsToShow.length / stepsPerPage) | 0;
    var maxPageIdx = numOfPages - 1 | 0;
    var pageIdx = Math.max(0, Math.min(match$3[0], maxPageIdx));
    paginationData = {
      numOfPages: numOfPages,
      stepsPerPage: stepsPerPage,
      pageIdx: pageIdx,
      stmtsToShow: stmtsToShow,
      thereAreBkmSteps: thereAreBkmSteps
    };
  } else {
    paginationData = undefined;
  }
  var actGoToPage = function (pageIdx) {
    setPageIdx(function (param) {
          return pageIdx;
        });
  };
  var actChangeCurIdx = function (newCurIdx) {
    if (-1 <= newCurIdx && newCurIdx <= (MM_editor_history.editorHistLength(hist) - 1 | 0)) {
      setCurIdx(function (param) {
            return newCurIdx;
          });
      return setCurEditorState(function (param) {
                  return MM_editor_history.editorHistGetSnapshotPreview(hist, newCurIdx, editorState);
                });
    }
    
  };
  var actPrev = function () {
    actChangeCurIdx(curIdx + 1 | 0);
  };
  var actNext = function () {
    actChangeCurIdx(curIdx - 1 | 0);
  };
  var prevIsDisabled = curIdx === (MM_editor_history.editorHistLength(hist) - 1 | 0);
  var nextIsDisabled = curIdx === -1;
  var rndButtons = function () {
    var thereAreBkmSteps = Core__Option.getOr(Core__Option.map(paginationData, (function (data) {
                return data.thereAreBkmSteps;
              })), false);
    return React.createElement(Expln_React_Row.make, {
                alignItems: "center",
                style: {
                  padding: "4px"
                },
                children: Caml_option.some(null)
              }, React.createElement(Button, {
                    onClick: (function (param) {
                        onRestore(curIdx);
                      }),
                    variant: "contained",
                    disabled: nextIsDisabled,
                    color: "grey",
                    children: "Restore this"
                  }), React.createElement(Button, {
                    onClick: (function (param) {
                        onClose();
                      }),
                    children: "Close"
                  }), React.createElement("span", {
                    title: "Show bookmarked steps only / show all steps"
                  }, React.createElement(IconButton, {
                        onClick: (function (param) {
                            setShowBkmOnly(function (prev) {
                                  return !prev;
                                });
                          }),
                        color: "primary",
                        disabled: !thereAreBkmSteps,
                        children: Caml_option.some(thereAreBkmSteps && showBkmOnly ? React.createElement(Bookmark, {}) : React.createElement(BookmarkBorder, {}))
                      })), React.createElement(Expln_React_Row.make, {
                    alignItems: "center",
                    spacing: 0,
                    children: Caml_option.some(null)
                  }, React.createElement(Button, {
                        onClick: (function (param) {
                            actPrev();
                          }),
                        disabled: prevIsDisabled,
                        children: "< PREV"
                      }), React.createElement("span", undefined, String(curIdx + 1 | 0)), React.createElement(Button, {
                        onClick: (function (param) {
                            actNext();
                          }),
                        disabled: nextIsDisabled,
                        children: "NEXT >"
                      })));
  };
  var rndMultilineText = function (text, renderer) {
    var style = text.trim() === "" ? ({
          padding: "4px"
        }) : ({
          padding: "0px"
        });
    return React.createElement(Paper, {
                style: style,
                variant: "outlined",
                children: Caml_option.some(text.trim() === "" || Belt_Option.isNone(renderer) ? React.createElement("pre", undefined, text) : Belt_Option.getExn(renderer)(text))
              });
  };
  var rndDescr = function (editorState) {
    return React.createElement(Expln_React_Row.make, {
                alignItems: "flex-start",
                spacing: 1,
                style: {
                  marginTop: "12px",
                  marginLeft: "7px"
                },
                children: Caml_option.some(null)
              }, React.createElement("span", undefined, "Description"), rndMultilineText(editorState.descr, (function (str) {
                      return React.createElement(Static_XML_to_HTML.make, {
                                  xmlStr: str
                                });
                    })));
  };
  var rndVars = function (editorState) {
    return React.createElement(Expln_React_Row.make, {
                alignItems: "flex-start",
                spacing: 1,
                style: {
                  marginTop: "3px",
                  marginLeft: "7px"
                },
                children: Caml_option.some(null)
              }, React.createElement("span", undefined, "Variables"), rndMultilineText(editorState.varsText, undefined));
  };
  var rndDisj = function (editorState) {
    return React.createElement(Expln_React_Row.make, {
                alignItems: "flex-start",
                spacing: 1,
                style: {
                  marginTop: "3px",
                  marginLeft: "7px"
                },
                children: Caml_option.some(null)
              }, React.createElement("span", undefined, "Disjoints"), rndMultilineText(editorState.disjText, undefined));
  };
  var rndPagination = function () {
    if (paginationData === undefined) {
      return null;
    }
    var paginationIsRequired = paginationData.stmtsToShow.length > paginationData.stepsPerPage;
    if (paginationIsRequired) {
      return React.createElement("div", {
                  style: {
                    padding: "5px"
                  }
                }, React.createElement(PaginationCmp.make, {
                      numOfPages: paginationData.numOfPages,
                      pageIdx: paginationData.pageIdx,
                      siblingCount: 1000,
                      itemsPerPage: paginationData.stepsPerPage,
                      showGoToPage: false,
                      showItemsPerPage: false,
                      onPageIdxChange: actGoToPage
                    }));
    } else {
      return null;
    }
  };
  var rndStmts = function (editorState) {
    if (paginationData === undefined) {
      return null;
    }
    var stmtBeginIdx = Math.imul(paginationData.pageIdx, paginationData.stepsPerPage);
    var stmtEndIdx = (stmtBeginIdx + paginationData.stepsPerPage | 0) - 1 | 0;
    return React.createElement(Expln_React_Column.make, {
                spacing: 0,
                children: Caml_option.some(paginationData.stmtsToShow.filter(function (param, i) {
                            if (stmtBeginIdx <= i) {
                              return i <= stmtEndIdx;
                            } else {
                              return false;
                            }
                          }).map(function (__x) {
                          var settings = editorState.preCtxData.settingsV.val;
                          return React.createElement(MM_cmp_user_stmt.make, {
                                      modalRef: modalRef,
                                      settingsVer: editorState.preCtxData.settingsV.ver,
                                      settings: settings,
                                      preCtxVer: editorState.preCtxData.ctxV.ver,
                                      varsText: editorState.varsText,
                                      wrkCtx: editorState.wrkCtx,
                                      frms: editorState.preCtxData.frms,
                                      parenCnt: editorState.preCtxData.parenCnt,
                                      syntaxTypes: editorState.preCtxData.syntaxTypes,
                                      parensMap: editorState.preCtxData.parensMap,
                                      typeColors: editorState.preCtxData.typeColors,
                                      preCtxColors: editorState.preCtxData.symColors,
                                      wrkCtxColors: editorState.wrkCtxColors,
                                      editStmtsByLeftClick: settings.editStmtsByLeftClick,
                                      longClickEnabled: settings.longClickEnabled,
                                      longClickDelayMs: settings.longClickDelayMs,
                                      defaultStmtType: settings.defaultStmtType,
                                      showVisByDefault: settings.showVisByDefault,
                                      viewOptions: {
                                        showCheckbox: false,
                                        showLabel: viewOptions.showLabel,
                                        showType: viewOptions.showType,
                                        showJstf: viewOptions.showJstf,
                                        inlineMode: viewOptions.inlineMode,
                                        smallBtns: viewOptions.smallBtns
                                      },
                                      readOnly: true,
                                      parenAc: false,
                                      toggleParenAc: (function () {
                                          
                                        }),
                                      stmt: __x,
                                      onLabelEditRequested: (function () {
                                          
                                        }),
                                      onLabelEditDone: (function (param) {
                                          
                                        }),
                                      onLabelEditCancel: (function (param) {
                                          
                                        }),
                                      onTypEditRequested: (function () {
                                          
                                        }),
                                      onTypEditDone: (function (param, param$1) {
                                          
                                        }),
                                      onContEditRequested: (function () {
                                          
                                        }),
                                      onContEditDone: (function (param) {
                                          
                                        }),
                                      onContEditCancel: (function (param) {
                                          
                                        }),
                                      onSyntaxTreeUpdatedWithoutContentChange: (function (newStmtCont) {
                                          var stmtId = __x.id;
                                          var update = function (__x) {
                                            return MM_wrk_editor.setStmtCont(__x, stmtId, newStmtCont);
                                          };
                                          setCurEditorState(function (stRes) {
                                                if (stRes.TAG === "Ok") {
                                                  return {
                                                          TAG: "Ok",
                                                          _0: update(stRes._0)
                                                        };
                                                } else {
                                                  return stRes;
                                                }
                                              });
                                        }),
                                      onJstfEditRequested: (function () {
                                          
                                        }),
                                      onJstfEditDone: (function (param) {
                                          
                                        }),
                                      onJstfEditCancel: (function (param) {
                                          
                                        }),
                                      checkboxDisabled: true,
                                      checkboxChecked: false,
                                      checkboxOnChange: (function (param, param$1) {
                                          
                                        }),
                                      onGenerateProof: (function () {
                                          
                                        }),
                                      onDebug: (function () {
                                          
                                        }),
                                      onOpenSubstitutionDialog: undefined,
                                      addStmtAbove: (function (param) {
                                          
                                        }),
                                      addStmtBelow: (function (param) {
                                          
                                        }),
                                      setShowTabs: (function (param) {
                                          
                                        }),
                                      openFrameExplorer: (function (param) {
                                          
                                        })
                                    });
                        }))
              });
  };
  var rndEditorState = function () {
    if (curEditorState.TAG !== "Ok") {
      return React.createElement("pre", {
                  style: {
                    color: "red"
                  }
                }, "Error reading editor history: " + curEditorState._0);
    }
    var editorState = curEditorState._0;
    return React.createElement(Expln_React_Column.make, {
                spacing: 0,
                children: Caml_option.some(null)
              }, rndDescr(editorState), rndVars(editorState), rndDisj(editorState), rndPagination(), rndStmts(editorState), rndPagination());
  };
  return React.createElement(Paper, {
              style: {
                padding: "10px"
              },
              children: Caml_option.some(null)
            }, React.createElement(AppBar, {
                  position: "sticky",
                  color: "white",
                  children: rndButtons()
                }), rndEditorState());
}

var make = MM_cmp_editor_hist;

exports.make = make;
/* react Not a pure module */
